<template>
  <div class="home-center">
    <div class="map">
      <home-map></home-map>
    </div>
    <!-- <div class="city-volume">
      <div class="city-volume-box1">
        <h3 class="home-tit">行程总里程统计</h3>
        <div>
          <bar :chartData="barHorData1" :dontNeedRightYaxis="true"></bar>
        </div>
      </div>
      <div class="city-volume-box2">
        <h3 class="home-tit">充电总次数统计</h3>
        <div>
          <bar-hor :chartData="barHorData[0]"></bar-hor>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
// import barHor from '@/component/barHor'
import homeMap from '../home/homeMap'
// import bar from '@/component/bar.vue'

export default {
  components: {
    // barHor,
    homeMap
    // bar
  },
  props: {
    VehAreaDistion: {
      type: Object,
      default () {
        return {
          // 充电总次数统计
          chargeStatistics: [],
          // 行驶总里程统计
          drivStatistics: [],
          geoDistribution: []
        }
      }
    }
  },
  data () {
    return {
      cityData: {
        series: [
          {
            data: [120, 132, 101, 134, 90, 230, 210, 22, 33, 333, 16, 123],
            name: '上海'
          },
          {
            data: [120, 132, 101, 134, 90, 230, 210, 92, 33, 121, 66, 127],
            name: '北京'
          },
          {
            data: [120, 132, 101, 134, 90, 230, 210, 82, 33, 55, 166, 77],
            name: '广州'
          },
          {
            data: [120, 132, 101, 134, 90, 230, 210, 42, 88, 55, 266, 177],
            name: '深圳'
          },
          {
            data: [120, 132, 101, 134, 90, 230, 210, 22, 33, 99, 366, 277],
            name: '重庆'
          }
        ],
        xAxisData: [
          '01月',
          '02月',
          '03月',
          '04月',
          '05月',
          '06月',
          '07月',
          '08月',
          '09月',
          '10月',
          '11月',
          '12月'
        ],
        padding: ['30', '0', '30', '50'],
        color: ['#8568FF', '#0FC9E4', '#FF753C', '#FFDE68', '#007CFF']
      },
      barData: {}
    }
  },
  computed: {
    barHorData1 () {
      if (this.VehAreaDistion.drivStatistics.data) {
        // // region 为了适配echarts漏洞，第一个设置为空
        // this.VehAreaDistion.drivStatistics.data[0].unshift('0')
        // this.VehAreaDistion.drivStatistics.data[1].unshift('0')
        // this.VehAreaDistion.drivStatistics.cityArray.unshift('')
        // // endregion
        // // region 为了适配echarts漏洞，最后一个设置为空
        // this.VehAreaDistion.drivStatistics.data[0].push('0')
        // this.VehAreaDistion.drivStatistics.data[1].push('0')
        // this.VehAreaDistion.drivStatistics.cityArray.push('')
        // endregion
        return {
          series: [
            {
              name: '新能源车',
              data: this.VehAreaDistion.drivStatistics.data[0].map(function (item, index, arr) {
                return Number(item)
              }),
              type: 'bar'
            },
            {
              name: '燃油车',
              data: this.VehAreaDistion.drivStatistics.data[1].map(function (item, index, arr) {
                return Number(item) > 0 ? Number(item) : 1
              }),
              type: 'bar'
            }
          ],
          yAxis: [
            {
              type: 'log',
              name: '新能源车',
              min: 1,
              axisLine: {
                lineStyle: {
                  color: '#8794A4'
                }
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            },
            {
              type: 'log',
              name: '燃油车',
              min: 0,
              axisLine: {
                lineStyle: {
                  color: '#8794A4'
                }
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            }
          ],
          xAxisData: this.VehAreaDistion.drivStatistics.cityArray,
          yAxisName: ['km'],
          colorStops1: ['#00B4F0 ', '#00B4F0'],
          colorStops2: ['#2A4CD8', '#2A4CD8'],
          left: 80,
          rotate: 50,
          isDouble: false
        }
      } else {
        return {}
      }
    },
    barHorData () {
      // chargeStatistics
      const barData = this.VehAreaDistion.chargeStatistics.map(d => {
        return {
          name: d.name,
          value: parseFloat(d.perCharge)
        }
      })
      // const barData2 = this.VehAreaDistion.drivStatistics.map(d => {
      //   return {
      //     name: d.name,
      //     value: parseFloat(d.perMileage)
      //   }
      // })
      if (barData.length > 10) barData.length = 10
      // if (barData2.length > 10) barData2.length = 10
      return [{
        barData,
        barWidth: 10,
        colorStops: ['#429FFD', '#00D6EB']
      }]
    }
  },
  mounted () {
    setTimeout(() => {
      this.barData = {
        series: [
          {
            data: [22.0, 44.9, 57.0, 12, 56, 22.0, 44.9, 57.0, 12, 56, 22.0, 44.9, 57.0, 12, 56, 22.0, 44.9, 57.0, 12, 56],
            // name: '车均充电次数',
            type: 'bar'
          },
          {
            data: [23.6, 55.9, 69.0, 89, 22.0, 44.9, 57.0, 12, 56, 23.6, 55.9, 69.0, 89, 22.0, 44.9, 57.0, 12, 56],
            // name: '车均充电总时间',
            type: 'bar'
          }
        ],
        xAxisData: [
          '1月', '2月', '3月', '4月', '1月', '2月', '3月', '4月'],
        yAxisName: ['次数(次）'],
        colorStops1: ['#00B4F0 ', '#08101C'],
        colorStops2: ['#2A4CD8', '#09101C'],
        left: 50
      }
    }, 3000)
  }
}
</script>

<style lang="scss" scoped>
.home-center {
  width: 100%;
  margin: 0 0.9rem 0 0 ;
  .map {
    width: 100%;
    // height: 15.7rem;
    height:78%;
    padding: 0.3rem;
    background: url("../../../assets/images/home/map.png") no-repeat;
    background-size: 100% 100%;
    margin: 0.1rem -0.3rem 0.34rem 0rem;
  }
  .city-volume {
    width: 100%;
    height: 4.1rem;
    display: flex;
    .city-volume-box1,
    .city-volume-box2 {
      background: url("../../../assets/images/home/bg-1.png") no-repeat;
      background-size: 100% 100%;
      padding: 0 0.28rem;
      box-sizing: border-box;
      width: 7.73rem;
    }
    .city-volume-box1 {
      margin-right: 0.25rem;
      & > div {
        width: 100%;
        height: 3rem;
      }
    }
    .city-volume-box2 {
      & > div {
        width: 100%;
        height: 3rem;
      }
    }
  }
}
</style>
